import { useQuery } from "@tanstack/react-query";

import { quoteRequestQuery } from "#modules/quoteRequests/infra/quoteRequest.query";

import { QuoteRequestDto } from "../infra/fetchQuoteRequest.api";

export const useQuoteRequest = ({
  quoteRequestId,
  options = {
    initialData: undefined,
    enabled: true,
    refetchInterval: undefined,
  },
}: {
  quoteRequestId: string | undefined;
  options?: {
    initialData?: QuoteRequestDto | null;
    enabled?: boolean;
    refetchInterval?: number;
  };
}) => {
  const { initialData, enabled = true } = options;

  const { data, ...rest } = useQuery({
    ...quoteRequestQuery(quoteRequestId),
    ...(initialData !== undefined && { initialData }),
    refetchInterval: options.refetchInterval,
    enabled,
  });

  return { quoteRequest: data, ...rest };
};
